import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useU2000AxiosAuthenticated from '../../u2000Core/axios/U2000UseAxiosAuthenticated';
import { U2000HandleApiError, type U2000ApiErrorResult } from '../../u2000Core/axios/U2000HandleApiError';
import { useToast } from '../../u2000Core/context/toast/U2000ToastContext';
import { NS } from '../U3204';
import {
  doReindexProductHelp,
  luHandleAppiError,
  u3204ParseU2200JobResponse,
  type U3204ProductHelpReindexBody,
  type U3204U2200Job,
} from '../U3204Service';

export function useU3204ProductHelpReindexHandlers() {
  const axios = useU2000AxiosAuthenticated();
  const { t } = useTranslation(NS);
  const toast = useToast();
  const [submitting, setSubmitting] = useState(false);

  const startReindex = useCallback(
    async (body: U3204ProductHelpReindexBody = {}): Promise<U3204U2200Job | null> => {
      setSubmitting(true);
      try {
        const response = await doReindexProductHelp(axios, body);
        const job = u3204ParseU2200JobResponse(response.data);
        if (!job?.id) {
          toast.error(t('admin.jobFailed'));
          return null;
        }
        return job;
      } catch (error: unknown) {
        const errorResult = U2000HandleApiError(error as Error, t, NS, luHandleAppiError) as U2000ApiErrorResult;
        if (errorResult.genericErrors?.length) {
          errorResult.genericErrors.forEach((err) => toast.error(err.text, err.title));
        }
        return null;
      } finally {
        setSubmitting(false);
      }
    },
    [axios, t, toast],
  );

  return { submitting, startReindex };
}
